import React from 'react';
import { ArrowSvgIcon, BagSvgIcon, ScreenSvgIcon, LightSvgIcon, SubmitSvgIcon } from '../SvgIcons';

export const DealerBox = [
    {
        id: 1,
        img: require('../../../../assets/images/dashboard-2/1.png'),
        name: 'Thompson lee',
        place: 'Malasiya'
    },
    {
        id: 2,
        img: require('../../../../assets/images/dashboard-2/8.png'),
        name: 'Johnson allon',
        place: 'Bangladesh'
    },
    {
        id: 3,
        img: require('../../../../assets/images/dashboard-2/3.png'),
        name: 'williams reed',
        place: 'Belgium'
    },
    {
        id: 4,
        img: require('../../../../assets/images/dashboard-2/4.png'),
        name: 'Jones king',
        place: 'Canada'
    },
    {
        id: 5,
        img: require('../../../../assets/images/dashboard-2/5.png'),
        name: 'Brown davis',
        place: 'China'
    },
    {
        id: 6,
        img: require('../../../../assets/images/dashboard-2/6.png'),
        name: 'Wilson Hill',
        place: 'Denmark'
    },
    {
        id: 7,
        img: require('../../../../assets/images/dashboard-2/7.png'),
        name: 'Anderson ban',
        place: 'Japan'
    },
    {
        id: 8,
        img: require('../../../../assets/images/dashboard-2/8.png'),
        name: 'Thompson lee',
        place: 'Malasiya'
    },
    {
        id: 9,
        img: require('../../../../assets/images/dashboard-2/8.png'),
        name: 'Thompson lee',
        place: 'Malasiya'
    },
    {
        id: 10,
        img: require('../../../../assets/images/dashboard-2/8.png'),
        name: 'Thompson lee',
        place: 'Malasiya'
    }
];

export const RecentOrders = [
    {
        id: 1,
        img: require('../../../../assets/images/dashboard/product-1.png'),
        name: 'Tarun Khator',
        percentage: '98.7%',
        exam: 'Half yearly Exam',
        value: require('../../../../assets/images/dashboard/graph-1.png'),
        prize: 'certificate + medal of owner',
        status: 'Active'
    },
    {
        id: 2,
        img: require('../../../../assets/images/dashboard/product-2.png'),
        // img: require('../../../../assets/images/dashboard/product-1.png'),
        name: 'Suresh Chaudhary ',
        percentage: '97.3%',
        exam: 'Half yearly Exam',
        value: require('../../../../assets/images/dashboard/graph-2.png'),
        prize: 'certificate + medal of owner',
        status: 'Active'
    },
    {
        id: 3,
        img: require('../../../../assets/images/dashboard/product-3.png'),
        // img: require('../../../../assets/images/dashboard/product-1.png'),
        name: 'Vivek',
        percentage: '96.8%',
        exam: 'Half yearly Exam',
        value: require('../../../../assets/images/dashboard/graph-3.png'),
        prize: 'certificate + medal of owner',
        status: 'Active'
    },
    {
        id: 4,
        img: require('../../../../assets/images/dashboard/product-4.png'),
        // img: require('../../../../assets/images/dashboard/product-1.png'),
        name: 'Permanand Kumawat',
        percentage: '95.3%',
        exam: 'Half yearly Exam',
        Graph: require('../../../../assets/images/dashboard/graph-4.png'),
        prize: 'certificate + medal of owner',
        status: 'Active'
    },
    {
        id: 5,
        img: require('../../../../assets/images/dashboard/product-5.png'),
        // img: require('../../../../assets/images/dashboard/product-1.png'),
        name: 'Gopal Choudhary',
        percentage: '95%',
        exam: 'Half yearly Exam',
        value: require('../../../../assets/images/dashboard/graph-5.png'),
        prize: 'certificate of owner',
        status: 'Active'
    }
];

export const LatestActivity = [
    {
        id: 1,
        icon: <ArrowSvgIcon />,
        name: 'Google project Apply Review',
        subtitle: 'Complete in 3 Hours',
    },
    {
        id: 2,
        icon: <BagSvgIcon />,
        name: 'Business Logo Create',
        subtitle: 'Complete in 2 Days',
    },
    {
        id: 3,
        icon: <LightSvgIcon />,
        name: 'Business Project Research',
        subtitle: 'Due in 1 hour',
    },
    {
        id: 4,
        icon: <ScreenSvgIcon />,
        name: 'Recruitment in IT Depertment',
        subtitle: 'Complete in 3 Hours',
    },
    {
        id: 5,
        icon: <SubmitSvgIcon />,
        name: 'Submit Riverfront Project',
        subtitle: 'Complete in 2 Days',
    }
];
